export const CLOCK_TYPE = {
  BROADCAST: 'Broadcast',
  STANDARD: 'Standard',
};
